var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { Login } from './Login';
import { LoginManager as manager, loginStore as store, LoginActions as actions, withLogin } from './LoginManager';
import { Route, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';

var Fancy = function (_Component) {
  _inherits(Fancy, _Component);

  function Fancy() {
    _classCallCheck(this, Fancy);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Fancy.prototype.render = function render() {
    return React.createElement(
      'div',
      null,
      'This is so Fancy!'
    );
  };

  return Fancy;
}(Component);

var logdown = require('logdown');
var console = logdown('rx-login-private-route', { prefixColor: '#689f38' });

export var PrivateRoute = function (_Component2) {
  _inherits(PrivateRoute, _Component2);

  function PrivateRoute(props) {
    _classCallCheck(this, PrivateRoute);

    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));

    console.log('in privateroute login with props: ' + JSON.stringify(props));

    var unsubscribe = store.subscribe(function () {

      var state = store.getState();
      console.log('privateroute APP loginStore state: ' + JSON.stringify(state));

      switch (state.state) {
        case actions.LOGIN_DONE:
          console.log('privateroute login done - change to authenticated');
          console.log('privateroute before state: ' + JSON.stringify(_this2.state));
          // this.setState({authenticated: true});
          console.log('privateroute privateroute before history push: ' + _this2.props);
          //this.props.history.push('/');
          console.log('privateroute after state: ' + JSON.stringify(_this2.state));
          break;

        case actions.EXPIRED:
        case actions.LOGOUT:
          console.log('in logout for set authenticated false');
          // this.setState({authenticated: false});
          break;

        default:
          break;
      }
    });
    return _this2;
  }

  PrivateRoute.prototype.render = function render() {
    var _this3 = this;

    console.log('in privateroute render with auth ' + this.props.authenticated);
    if (this.props.authenticated) {
      console.log('in authenticated');
      return React.createElement(Route, { render: function render(props) {
          return React.createElement(_this3.props.component, _extends({ loginManager: _this3.props.loginManager }, _this3.props));
        } });
    } else {
      console.log('not authenticated - redirect to login');
      return React.createElement(Redirect, { to: {
          pathname: '/login',
          state: { from: this.props.location }
        } });
    }
    // return (
    //   <Route {...this.props} render={props => (
    //     props.authenticated ? (
    //       <this.props.component loginManager={this.props.loginManager} {...this.props} />
    //     ) : (
    //       <Redirect to={{
    //         pathname: '/login',
    //         state: { from: props.location }
    //       }}/>
    //   )
    // )}/>
    //)
  };

  return PrivateRoute;
}(Component);

// const PrivateRoute = ({ component: Component, authenticated: authenticated, loginManager: loginManager, ...rest }) => { 
//   console.log('in private route with authenticated: ' + authenticated);
//   return (
//     <Route {...rest} render={props => (
//       authenticated ? (
//         <Component loginManager={loginManager} {...rest} />
//       ) : (
//         <Redirect to={{
//           pathname: '/login',
//           state: { from: props.location }
//         }}/>
//       )
//     )}/>
//   )
// }

// module.exports =  {
//   Fancy: Fancy,
//   Login: Login,
//   LoginManager: manager,
//   LoginManagerStore: store,
//   LoginManagerActions: actions,
//   PrivateRoute: PrivateRoute,
//   withLogin: withLogin
// }

// export * from 'Login';
// export Fancy;